export const HEADER = 'Save changes';
export const ARE_YOU_SURE_TEXT = 'Are you sure you want to save changes?';
export const CHANGES_REFLECTED_TEXT =
  "Once saved, changes will be reflected in customer's Assets.";
